import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Bio from "@/pages/Bio";
import Podcast from "@/pages/Podcast";
import Books from "@/pages/Books";
import Speaking from "@/pages/Speaking";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import PressKit from "@/pages/PressKit";
import SEOTopic from "@/pages/SEOTopic";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import AuthCallback from "@/admin/AuthCallback";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_KEY = "ms_session_id";

function getSessionId() {
  let s = sessionStorage.getItem(SESSION_KEY);
  if (!s) {
    s = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
    sessionStorage.setItem(SESSION_KEY, s);
  }
  return s;
}

function PageTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    axios.post(`${API}/track`, {
      path: pathname || "/",
      referrer: document.referrer || "",
      screen_width: window.innerWidth || null,
      session_id: getSessionId(),
    }).catch(() => {});
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Synchronous check during render — runs BEFORE any route's useEffect / authMe call.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <PageTracker />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/bio" element={<Bio />} />
        <Route path="/podcast" element={<Podcast />} />
        <Route path="/books" element={<Books />} />
        <Route path="/speaking" element={<Speaking />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/press-kit" element={<PressKit />} />
        <Route path="/topics/:slug" element={<SEOTopic />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
